import React, { Component } from 'react';
import {Route} from "react-router-dom";

import NavPersonal from "./NavPersonal";
import PagRazones from "./PagRazones";
import PagPlanSeguridad from "./PagPlanSeguridad";
import PagMusic from "./PagMusic";
import PagImages from "./PagImagenes";


export default class RutasPagsPersonal extends Component {
    render() {
        return (
            <div className="ContainerPersonal">
                <NavPersonal/>
                <div className="ContenidoPaginaUser">
                    <Route path="/user/razones" component={PagRazones}/>
                    <Route path="/user/plan_seguridad" component={PagPlanSeguridad}/>
                    <Route path="/user/imagenes" component={PagImages}/>
                    <Route path="/user/musica" component={PagMusic}/>
                </div>
            </div>
        )
    }
}
